export function summarizePledgesByProduct(rows) {
  const list = Array.isArray(rows) ? rows : [];
  return list.reduce(
    (acc, row) => {
      acc.total_count += Number(row?.pledge_count || 0);
      acc.total_amount += Number(row?.pledge_total || 0);
      acc.paid_amount += Number(row?.paid_total || 0);
      acc.balance_amount += Number(row?.balance_total || 0);
      return acc;
    },
    { total_count: 0, total_amount: 0, paid_amount: 0, balance_amount: 0 }
  );
}

export function buildPledgesByProductParams(options = {}) {
  const params = new URLSearchParams();
  const status = String(options.status || 'all').toLowerCase();
  params.append('status', status);

  if (options.kotilinga) params.append('kotilinga', 'true');
  if (options.temple) params.append('temple', 'true');

  if (options.parent_category_slugs) {
    params.append('parent_category_slugs', String(options.parent_category_slugs));
  }
  if (options.exclude_parent_category_slugs) {
    params.append('exclude_parent_category_slugs', String(options.exclude_parent_category_slugs));
  }

  if (options.start) params.append('start', String(options.start));
  if (options.end) params.append('end', String(options.end));
  if (options.q) params.append('q', String(options.q));

  return params;
}

export async function fetchPledgesByProduct(getFn, options = {}) {
  const params = buildPledgesByProductParams(options);
  const query = params.toString();
  const url = query
    ? `/ldb/reports/pledges/by-product?${query}`
    : '/ldb/reports/pledges/by-product';
  const res = await getFn(url);
  const rows = Array.isArray(res?.data) ? res.data : [];
  return {
    rows,
    summary: summarizePledgesByProduct(rows),
  };
}
